import type { InstallPromptEvent } from "@/lib/pwa";
import { create } from "zustand";

type UIState = {
	quickAddOpen: boolean;
	setQuickAddOpen: (open: boolean) => void;
	/** True while the outbox is being pushed to or pulled from the API. */
	syncing: boolean;
	setSyncing: (syncing: boolean) => void;
	/** The task shown in the detail sheet, if any. */
	openTaskId: string | null;
	setOpenTaskId: (id: string | null) => void;
	/** The deferred browser install prompt, when the app can be installed. */
	installPrompt: InstallPromptEvent | null;
};

export const useUIStore = create<UIState>()((set) => ({
	quickAddOpen: false,
	setQuickAddOpen: (quickAddOpen) => set({ quickAddOpen }),
	syncing: false,
	setSyncing: (syncing) => set({ syncing }),
	openTaskId: null,
	setOpenTaskId: (openTaskId) => set({ openTaskId }),
	installPrompt: null,
}));
